import type sv from '../sv/notifications'

const notifications: typeof sv = {
  panel: {
    title: 'Notifications',
    description: 'Your latest notifications',
    bell: 'Notifications',
    markAllRead: 'Mark all as read',
    empty: 'No notifications',
    loadMore: 'Load more...',
  },
  tabs: {
    all: 'All',
    notification: 'Notifications',
    activity: 'Activity',
  },
  time: {
    justNow: 'Just now',
    minutesAgo: '{{count}} min ago',
    hoursAgo_one: '{{count}} hour ago',
    hoursAgo_other: '{{count}} hours ago',
    daysAgo_one: '{{count}} day ago',
    daysAgo_other: '{{count}} days ago',
  },
}

export default notifications
